import { ETrueFalse } from 'enums/trueFalse';

const trueFalseSelect = [
    {
        value: ETrueFalse.TRUE,
        labelcz: 'ANO'
    },
    {
        value: ETrueFalse.FALSE,
        labelcz: 'NE'
    }
];

export default trueFalseSelect;
